export default "__VITE_ASSET__Bfa6ajz5__"